import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { ThemingService } from '@shared/services/theming.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnChanges {
  @Input() isAuthenticated;

  constructor(private themeService: ThemingService, private authService: AuthService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.isAuthenticated = this.isAuthenticated; // NOSONAR: Self-assignment is intentional
  }

  ngOnInit() {
    if (this.isAuthenticated) {
    }
  }

  IncreaseFontSize(value: string) {
    const basesize = 14;
    const els = document.documentElement;
    els.style.fontSize = basesize + Number(value) + 'px';
  }
}
